<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品品牌列表</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline">
      <el-form-item label="商品品牌名称">
        <el-input
          size="small"
          clearable
          v-model="formInline.brandName"
          placeholder="请输入商品品牌名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          size="small"
          clearable
          filterable
          v-model="formInline.dictStatus"
          placeholder="请选择商品品牌状态"
        >
          <el-option
            v-for="item in proTypeListOption"
            :key="item.id + '-smlxkey'"
            :label="item.key"
            :value="item.val"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <!-- <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button> -->
      </el-form-item>
      <el-form-item>
        <el-button size="small"
                   type="primary"
                   icon="el-icon-plus" @click="handleEdit">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column sortable prop="brandName" label="品牌名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="dictStatus" label="状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.dictStatus"
            :active-value="1"   :inactive-value="0"
            active-text="启用" inactive-text="禁用"
            @change="editType($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column sortable label="品牌图标" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            style="width: 80px; height: 50px"
            :src="scope.row.imageOss"
            :preview-src-list="[scope.row.imageOss]">
          </el-image>
        </template>
      </el-table-column>
<!--      <el-table-column sortable label="分类是否推荐" show-overflow-tooltip>-->
<!--        <template slot-scope="scope">-->
<!--          <el-switch-->
<!--            v-model="scope.row.isRecommend"-->
<!--            @change="recommendChange($event, scope.row)"-->
<!--            :active-value="'1'"-->
<!--            size="mini"-->
<!--            :inactive-value="'0'"-->
<!--          >-->
<!--          </el-switch>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column sortable label="分类推荐图片" show-overflow-tooltip>-->
<!--        <template slot-scope="scope">-->
<!--          <el-image-->
<!--            v-if="scope.row.recommendImageOssUrl"-->
<!--            style="width: 80px; height: 50px"-->
<!--            :src="scope.row.recommendImageOssUrl"-->
<!--            :preview-src-list="[scope.row.recommendImageOssUrl]">-->
<!--          </el-image>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column sortable prop="createDate" label="创建时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="updateDate" label="修改时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.updateDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @close="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item label="品牌名称" prop="brandName">
              <el-input size="small" v-model.trim="editForm.brandName" @change="change" placeholder="请输入分类名称"></el-input>
            </el-form-item>
<!--            <el-form-item label="分类排序" prop="order">-->
<!--              <el-input size="small" v-model.trim="editForm.order" @change="change" placeholder="请输入分类排序"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="品牌图标" prop="imageOss">
              <el-upload
                v-loading="uploading"
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :http-request="nationalUploadRequest"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.imageOss" :src="editForm.imageOss" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="img_size_tip">避免影响小程序内显示效果，请上传：20px*20px大小或等比例图片</div>
              </el-upload>
            </el-form-item>
<!--            <el-form-item label="分类推荐" prop="isRecommend">-->
<!--              <el-switch-->
<!--                v-model="editForm.isRecommend"-->
<!--                active-value="1"-->
<!--                size="mini"-->
<!--                inactive-value="0"-->
<!--                active-text="是"-->
<!--                inactive-text="否"-->
<!--                @change="recommendChange2($event, editForm.isRecommend)"-->
<!--              >-->
<!--              </el-switch>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="分类推荐图片" prop="recommendImageNo">-->
<!--              <el-upload-->
<!--                v-loading="uploading"-->
<!--                class="avatar-uploader"-->
<!--                action="#"-->
<!--                :show-file-list="false"-->
<!--                :http-request="nationalUploadRequest2"-->
<!--                :before-upload="beforeAvatarUpload">-->
<!--                <img v-if="editForm.recommendImageOssUrl" :src="editForm.recommendImageOssUrl" class="avatar">-->
<!--                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                <div slot="tip" class="img_size_tip">避免影响小程序内显示效果，请上传：345px*120px大小或等比例图片</div>-->
<!--              </el-upload>-->
<!--            </el-form-item>-->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>




</template>

  <script>
  import {upimg} from '@/api/userMG'
  import Pagination from '../../components/Pagination'
  import {
    editClassiFication,
    brandList,
    addBrand,
    updateBrand,
    delBrand,
    updateState
  } from "../../api/basisMG";

  export default {
    data() {
      return {
        loading: false, //是显示加载
        uploading:false,
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          brandName:null,
          id:'',
          imageNo:null
        },
        formInline: {
          pageNum: 1,
          pageSize: 10,
        },
        rules:{
          brandName:[ { required: true, message: '请输入分类名称',  }]
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        proTypeListOption:[
          {
            key:'启用',
            val:1,
            id:1
          },
          {
            key:'禁用',
            val:0,
            id:2
          }
        ]
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      beforeAvatarUpload(file) {
        // console.log(file,'图片文件before');
        const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('只能上传jpg或png格式!');
        }
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
        // return isLt2M;
      },
      //  分类图标自定义上传
      nationalUploadRequest(filePath){
        this.uploading = true
        let formData = new FormData()
        formData.append('file',filePath.file)
        upimg(formData).then(res=>{
          if(res.rsp_code==200){
            this.uploading = false
            this.editForm.imageNo = res.body.imageNo; //提交参数 图片标识串
            this.editForm.imageOss = res.body.ossUrl; // 上传后回显
          }else{
            this.uploading = false
            this.$message.error('上传失败!');
          }
        })
      },
      nationalUploadRequest2(filePath){
        this.uploading = true
        let formData = new FormData()
        formData.append('file',filePath.file)
        upimg(formData).then(res=>{
          if(res.rsp_code==200){
            this.uploading = false
            this.editForm.recommendImageNo = res.body.imageNo; //提交参数 图片标识串
            this.editForm.recommendImageOssUrl = res.body.ossUrl; // 上传后回显
          }else{
            this.uploading = false
            this.$message.error('上传失败!');
          }
        })
      },
      // 获取品牌列表
      getdata(parameter) {
        this.loading = true
        brandList(parameter)
          .then(res => {
            this.loading = false
            if (res.code !== 200) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.total
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.pageNum=1
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          // this.editForm = row
          this.editForm.brandName = row.brandName
          this.editForm.id = row.id
          // this.editForm.order = row.order
          this.editForm.imageOss = row.imageOss
          this.editForm.imageNo = row.imageNo
          // this.editForm.isRecommend = row.isRecommend,
          //   this.editForm.recommendImageNo = row.recommendImageNo
          // this.editForm.recommendImageOssUrl = row.recommendImageOssUrl
          console.log(this.editForm)
        } else {
          this.title = '添加'
          this.editForm.isRecommend = '0'
          this.editForm = {imageOss:''}
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let subType = this.title == '修改'?updateBrand:addBrand
            subType(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.rsp_code==200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delBrand(row.id)
              .then(res => {
                if (res.rsp_code==200) {
                  this.$message({
                    type: 'success',
                    message: '已删除!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false;
        this.$refs[formName].resetFields()
        this.editForm = {
          brandName:null,
            id:'',
            imageNo:null
        }
      },
      change(){
        this.$forceUpdate();  //强制刷新
      },
      recommendChange($event, row) {
        let par = {
          recommend: $event,
          id: row.id,
        };
        // if (row.underCarriage == 0) {
        //   this.$message.warning("未上架商品不能设置推荐！");
        //   row.isRecommend = 1;
        //   return;
        // }
        let text = row.isRecommend == 1 ? "设为推荐" : "取消推荐";
        this.$confirm("确定要把" + '"' + row.name + '"' + text + "吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            return editClassiFication(row);
          })
          .then((res) => {
            if (res.rsp_code == 200) {
              this.$message.success(text + "成功！");
              this.getdata(this.formInline);
            }
          })
          .catch(function () {
            row.isRecommend = row.isRecommend === 0 ? 1 : 0;
          });
      },
      recommendChange2($event, isRecommend) {
        this.editForm.isRecommend = isRecommend
      },
      editType: function(event, row) {
        this.loading = true
        let parm = {
          state: event,
          id: row.id,
        }
        // 修改状态
        updateState(parm).then(res => {
          this.loading = false
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.$message({
              type: 'success',
              message: '状态修改成功'
            })
            this.getdata(this.formInline)
          }
        })
      },
    }
  }
  </script>

<style>
.el-upload__tip{
  line-height: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>
<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/product/brands.vue